import React from 'react';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { CenteredFlexBox } from '../../../../../Components/FlexBox';
import IconButton from '../../../../../Components/Button/IconButton';
import StyledSwitch from '../../../../../Components/Inputs/StyledSwitch';

const WaveFilterOptions = function WaveFilterOptions({
  active,
  onEdit,
  onToggle,
}) {
  const handleEdit = (e) => {
    e.stopPropagation();
    if (onEdit) onEdit();
  };

  const handleToggle = (e) => {
    e.stopPropagation();
    if (onToggle) onToggle();
  };

  return (
    <CenteredFlexBox gap="32px" justifyContent="flex-end">
      <IconButton id="edit-filter-btn" title="EDIT_FILTER" onClick={handleEdit}>
        <EditRoundedIcon />
      </IconButton>
      <StyledSwitch
        id="toggle-filter-switch"
        checked={active}
        onClick={handleToggle}
        size="large"
      />
    </CenteredFlexBox>
  );
};

export default WaveFilterOptions;
